import './media/css/App.css';
import React from 'react';
import AppTopHeader from './Components/AppTopHeader.mjs';
import AppBody from "./Components/AppBody.mjs";
import Auth from './Components/Auth.mjs';
import AppToolbar from "./Components/Body/AppToolbar.mjs";

class App extends React.Component {
	constructor(opts) {
		super(opts);
		this.state = { loggedIn: window.glob.getStatus("loggedIn") };
		this.uid = window.glob.generateUid();
	};
	componentDidMount() {
		window.glob.register('loggedIn',(l)=> { this.setState({loggedIn: l }) }, this.uid );
	};
	componentWillUnmount() {
		window.glob.unregister('loggedIn',this.uid );
	}
	render() {
		const body = typeof this.state.loggedIn === 'undefined' ?
			(<h3 className={"mt-3 text-center"}>Avvio app…</h3>) :
			( this.state.loggedIn ? <AppBody /> : <Auth /> );
		return (
			<div className="App">
				<AppTopHeader loggedIn={this.state.loggedIn} />
				<AppToolbar loggedIn={this.state.loggedIn} />
				{ body }
			</div>
		);
	}
}

export default App;
